import { render, staticRenderFns } from "./SkillAmountsCpt.vue?vue&type=template&id=69baa00e&"
import script from "./SkillAmountsCpt.vue?vue&type=script&lang=ts&"
export * from "./SkillAmountsCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports